<template>
  <div class="card-air" :class="{ disable: isDisconnect }" disabled="disabled">
    <div class="item-air">
      <circle-slider
        :side="120"
        v-model="val3"
        progress-color="#ffc107"
        :progress-width="3"
        :knob-radius="5"
        knob-color="#ffc107"
        circle-color="#fff"
        class="ml-3"
        :max="30"
        :min="17"
        :class="{ disable_temp: noTemp }"
      >
      </circle-slider>
      <div class="stack">
        <div class="img">
          <!-- <img src="@/assets/icon/air_condition.svg" /> -->
          <icon-base
            viewBox="0 0 375 374.999991"
            icon-name="Air-Condition"
            width="40"
            height="40"
            :iconColor="color"
            ><icon-air-condition
          /></icon-base>
        </div>
        <p :style="'color :' + colorText" v-if="noTemp != true">{{ val3 }}°C</p>
        <vs-switch
          v-model="switch1"
          color="#ffc107"
          :disabled="isDisonnect"
        >
          <span slot="on">On</span>
          <span slot="off">Off</span>
        </vs-switch>
      </div>
    </div>
  </div>
</template>

<script>
import IconAirCondition from "@/assets/icon/Icons/IconAirCondition.vue";
export default {
  components: {
    IconAirCondition,
  },
  computed: {
    color: function () {
      return this.switch1 == true ? "#ffc107" : "#EFEFEF";
    },
    colorText: function () {
      return this.switch1 == true ? "#000" : "#989898";
    },
  },
  props: {
    // isDisconnect: {
    //   type: Boolean,
    //   default: true,
    // },
    device_id: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      val3: 25,
      val3Before: 0,
      switch1: true,
      isDisconnect: false,
      statusOnTemp: true,
      interval: null,
      noTemp: false,
    };
  },
  async mounted() {
    // await this.getStatus();
    // await this.getStatus2();

    // await this.callData();
    this.statusOnTemp = true;
    // if (this.interval != null) {
    //   clearTimeout(this.interval);
    // }
    // this.interval = setInterval(async () => {
    //   await this.getStatus();
    //   await this.getStatus2();
    // }, 20 * 1000);


  },
  beforeDestroy() {
    console.log("beforeDestroy");
    clearTimeout(this.interval);
  },
  watch: {
    val3: function () {
      if (this.statusOnTemp == true) {
        if (this.val3 != this.val3Before) {
          this.onTemp();
        }
        // console.log('val3');
      }
    },
  },
  methods: {
    async callData() {
      await this.getStatus();
      await this.getStatus2();
      this.interval = setTimeout(async () => {
        await this.callData();
      }, 20 * 1000);
    },
    async getStatus() {
      let res = await this.$API.get("tuya/device/status/" + this.device_id);
      // console.log(this.device_id, res);
      if (res.status === 200 && res.data.success == true) {
        // this.switch1 = res.data.result.power == 1 ? true : false;
        this.val3 = res.data.result.temp;
        this.val3Before = res.data.result.temp;
        this.isDisconnect = !res.data.success;
        if (this.val3 > 11) {
          this.noTemp = false;
        }
      } else {
        this.isDisconnect = true;
      }
    },
    async getStatus2() {
      let res = await this.$API.get("tuya/get/air/power/" + this.device_id);
      // console.log('getStatus2',this.device_id, res);
      if (res.status === 200) {
        this.switch1 = res.data.status == "On" ? true : false;
        // this.val3 = res.data.result.temp;
        // this.val3Before = res.data.result.temp;
        // this.isDisconnect = !res.data.success;
      }
    },
    async onAir() {
      console.log(this.switch1);
      let status = this.switch1;
      let body = {
        device: this.device_id,
        mode: "power",
        value: status == true ? 0 : 1,
      };
      console.log(body);
      let res = await this.$API.post("tuya/air/command", body);
      console.log(res);
      if (res.status === 200) {
        if (res.data.success != true) {
          this.switch1 = status;
        }
      }
    },
    async onTemp() {
      console.log(this.val3, this.val3Before);
      let temp = this.val3;
      let body = {
        device: this.device_id,
        mode: "temp",
        value: temp,
      };
      console.log(body);
      let res = await this.$API.post("tuya/air/command", body);
      console.log(res);
      if (res.status === 200) {
        if (res.data.success != true) {
          this.val3Before = temp;
          this.switch1 = true;
        } else {
          this.val3 = this.val3Before;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-air {
  // border: #ffc107 1px solid;
  border-radius: 5000px;
  padding: 10px;
  // margin: 0 10px 10px 0;
  background-color: #ffffff;
  width: 110px;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  .item-air {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    top: -15px;
    right: 30px;

    .stack {
      display: block;
      position: relative;
      top: 15px;
      right: 85px;
      // box-shadow: 1px 1px 3px 0.5px #cecece;
      border-radius: 500px;
      height: 100px;
      width: 100px;
      .img {
        display: flex;
        justify-content: center;
        img {
          width: 80%;
        }
      }
      p {
        text-align: center;
        margin-bottom: 2px;
        font-size: 1rem;
      }
    }
  }
}
.disable {
  //  width: 120px;
  pointer-events: none;
  background-color: #7c7c7c8c;
  //   position: fixed;
  //     display: block;
  // border-radius: 5000px;
  // z-index: 100;
}
.disable_temp {
  pointer-events: none;
}
</style>